import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "./firebase";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "./api";

export default function LoginPage() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      // Firebase client login
      await signInWithEmailAndPassword(auth, email.trim(), password);

      // Optional: hit backend /auth/login to validate token path
      await apiFetch("/auth/login", { method: "POST" });

      navigate("/", { replace: true });
    } catch (err) {
      setError(err?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen relative overflow-hidden font-roboto">
      <div className="absolute inset-0 bg-gradient-to-br from-secondary via-back to-tertiary" />
      <div className="absolute -top-24 -left-24 h-80 w-80 rounded-full bg-primary/20 blur-3xl" />
      <div className="absolute -bottom-28 -right-28 h-96 w-96 rounded-full bg-button/25 blur-3xl" />

      <div className="relative min-h-screen flex items-center justify-center px-4">
        <div className="w-full max-w-md">
          <div className="mb-6 text-center">
            <div className="inline-flex items-center justify-center rounded-2xl px-4 py-2 bg-white/60 border border-white/50 shadow-sm">
              <span className="font-blackOpsOne text-primary text-xl tracking-wide">
                Agile GPS
              </span>
            </div>
            <h1 className="mt-4 text-2xl font-semibold text-primary">Welcome back</h1>
            <p className="mt-1 text-sm text-textsec">Login with your existing account.</p>
          </div>

          <div className="rounded-2xl border border-white/50 bg-white/60 backdrop-blur-xl shadow-lg">
            <form onSubmit={handleSubmit} className="p-6 sm:p-8 space-y-4">
              <div>
                <label className="block text-sm font-medium text-textsec">Email</label>
                <input
                  className="mt-1 w-full rounded-xl bg-inputssecondary border border-inputsborder/40 px-4 py-3 text-textsec outline-none focus:ring-4 focus:ring-button/20 focus:border-button/70"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                  placeholder="you@company.com"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-textsec">Password</label>
                <input
                  className="mt-1 w-full rounded-xl bg-inputssecondary border border-inputsborder/40 px-4 py-3 text-textsec outline-none focus:ring-4 focus:ring-button/20 focus:border-button/70"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                  placeholder="••••••••"
                  required
                />
              </div>

              {error ? (
                <div className="rounded-xl border border-c1/30 bg-c1/10 px-4 py-3 text-sm text-primary">
                  {error}
                </div>
              ) : null}

              <button
                type="submit"
                disabled={loading}
                className="w-full rounded-xl bg-gradient-to-r from-button to-primary text-white font-semibold py-3 shadow-md hover:opacity-95 disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {loading ? "Signing in..." : "Login"}
              </button>

              <p className="text-center text-xs text-textsec/70">
                Protected by Firebase Auth
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}